import React from 'react';
import { Link } from 'react-router-dom';
import './layout.css';
import { Path } from 'components/Path/Path';
import * as api from 'api.js';
import { useLocation } from 'react-router-dom';

export function Layout({ children, infobar = '' }) {
    return (
        <>
            <SiteHeader infobar={infobar} />
            {children}
        </>
    );
}

function SiteHeader({ infobar }) {
    return (
        <div className="top_bars_cont">
            <div className="upper_navbar_cont">
                <Navbar />
            </div>
            <div className="lower_navbar_cont">
                <PageTitle />
                <Infobar content={infobar} />
            </div>
        </div>
    );
}

function Navbar() {
    //const history = useHistory();

    return (
        <nav>
            <div className="navbar_main">
                <div className="navbar_item">
                    <Link to="/transceivers">TRANSCEIVERS</Link>
                </div>
                <div className="navbar_item">
                    <Link to="/users">USERS</Link>
                </div>
                <div className="navbar_item">
                    <Link to="/search">SEARCH</Link>
                </div>
                <div className="navbar_item" onClick={() => api.logout()}>
                    LOGOUT
                </div>
            </div>
        </nav>
    );
}

function PageTitle() {
    const location = useLocation();

    let title = location.pathname;
    if (title === '/') {
        title = 'transceivers';
    } else {
        title = title.substring(1);
    }

    return (
        <div className="page_title_cont">
            <div className="page_title">{title.toUpperCase()}</div>
            <div className="page_title_arrow_tip"></div>
        </div>
    );
}

function Infobar({ content }) {
    let component = '';

    if (content === 'path') {
        component = <Path />;
    }

    return <div className="infobar_main">{component}</div>;
}
